// src/config.ts

type Config = {
    API_URL: string;
};

// REACT_APP_API_URL lets local development point at a backend running on this machine without
// editing (and accidentally committing) this file. Unset, it behaves exactly as before.
const development: Config = {
    API_URL: process.env.REACT_APP_API_URL || 'https://api.goly-esa.sk/api',
};

const production: Config = {
    API_URL: 'https://api.goly-esa.sk/api',
};

const configMap = {
    development,
    production,
};

// Use type assertion to ensure `process.env.NODE_ENV` is a valid environment
const env = process.env.NODE_ENV as 'development' | 'production';

const config: Config = configMap[env] || development;

export default config;
